<!--
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2022-07-21 14:09:11
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-06-07 13:51:37
-->
<template>
  <div class="tobe_member_con" :style="{marginTop:fromPage=='mine'?'-40px':'0'}">
    <div v-if="!isMember" class="c-fc-center bg-white c-m-lr-30 c-p-20 c-b-r-30">
      <img src="@/assets/images/star.png" class="c-w-50"></img>
      <div class="tc m-t-20">成为会员, 享受更多优惠及礼遇</div>
      <div class="tc m-t-20">
        <van-button
          color="var(--tc)"
          size="small"
          @click="handleToRegisterMember"
          >注册/登录会员</van-button
        >
      </div>
    </div>
    <div v-else :class="[{'member_info_con_mine':fromPage=='mine'},'c-f-bt member_info_con bg-white c-m-lr-30 c-p-20 c-b-r-30']" >
      <div>
        <div class="c-f c-m-b-15">
          <!-- <img v-if="fromPage!=='mine'" :src="memberInfo.Photo" class="c-w-80 c-m-r-10 c-b-r%-50"></img> -->
          <div>
            <p class="c-ft-35 bold-600">{{memberInfo.MemberName}}</p>
            <p class="card_no_con c-m-t-20 c-ft-24">{{memberInfo.MobilePhone}}</p>
            <p style="font-size: 12px;" >总余额：{{memberInfo.Account}}</p>
            <p style="font-size: 12px;" >可用积分：{{memberInfo.Integral}}</p>
            <p style="font-size: 12px;" >累计积分：{{memberInfo.ConsumeIntegral}}</p>
          </div>
         
        </div>
        <p v-if="fromPage!=='mine'">
           <van-button
          color="var(--tc)"
          size="small"
          round
          @click="handleToCoupon"
          >{{couponCount}}张礼券可用</van-button
        >
        </p>
      </div>
      <div
            class="code_img_box"
            @click="showCode = true"
          >
            <div class="c-w-40 c-h-40 bg-white c-zindex-1 c-b-r-10 click_img_con">
              
              <img src="@/assets/images/click.png" class="c-w-40"></img>
            </div>
            <div class="code_con">
               <vue-qr :text="qrCode" class="qr_code"></vue-qr>
            </div>
           
            <div
              class="m-t-8 c-ft-20 c-t-c"
            >支付核销码!</div>
            <div
              class="m-t-20 c-ft-24 c-t-c"
              v-if="fromPage=='mine'"
            >余额 ￥<span class="c-ft-36">{{memberInfo.Account}}</span></div>
          </div>
    </div>
  </div>
</template>

<script>
import { setToken } from "@/utils/auth";

import {
  getUserCardInfo
} from "@/api/member";
import {getMyTicketCount} from '@/api/coupon'
import { handleSessionStorage,handleAuthUserInfo,handleLocalStorage } from "@/utils/index";
export default {
  name: "MemberCom",
  props: {
    datas:Object,
    fromPage:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      memberInfo:{},
      isMember: false,
      showCode:false,
      qrCode:'222',
      couponCount:0
    };
  },
   watch: {
    "$store.state.vpnId"(val) {
      
      this.vpnId = val;
      this.handleInitMemberInfo()
    this.handleGetCouponCount()

    },
  },
  created() {
    this.vpnId = this.$store.state.vpnId;
    if(this.vpnId){
      this.handleInitMemberInfo()
    this.handleGetCouponCount()

    }
    
  },
  mounted() {},
  methods: {
    handleSetShow(type) {
      return this.datas.showContents.includes(type);
    },
    handleInitMemberInfo(){
      getUserCardInfo({ vpnId: this.vpnId }).then((res) => {
        if(res.Code){
          this.isMember=false
          return
        }
        if(res.Token){
           setToken(res.Token);
        }
          let info = handleSessionStorage.get("wxUserInfo")
          this.isMember=true
          this.memberInfo = {
            WxUserImg:info&&info.img,
            MemberName: res.MemberName,
            MobilePhone: res.MobilePhone,
            Account:res.Account,
            MemberAccountId:res.MemberAccountId,
            CardCode:res.CardCode,
            Integral:res.Integral,
            ConsumeIntegral:res.ConsumeIntegral,
          };
      });
    },
    handleGetCouponCount(){
      getMyTicketCount({vpnId:this.vpnId }).then(res=>{
        this.couponCount=res.AvalibleTicketTotal
      })
    },
    handleToRegisterMember() {
      const _this=this
      handleLocalStorage.set('registerAfterPage',{name:'HomePage'})
      handleAuthUserInfo(handleToNext)
      //   this.$emit('click', 'order');
      function handleToNext(){
        _this.$router.push({
          name: "ValidMember",
        })
      } 
    },
    handleToCoupon(){
      this.$router.push({
        name: "MyCouponList",
      });
    }
  },
};
</script>
<style scoped lang="scss">
.tobe_member_con{
  position: relative;
}
.member_info_con{

  
  &.member_info_con_mine{
    height: 280px;
    background: url('../../../assets/images/golden-card.png') no-repeat top left/100% 100%!important;
    align-items: start;
    padding: 30px!important;
  }
 
  .card_no_con{
    color:#8A8A8A;
  }
  .code_img_box{
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    .code_con{
      border-radius: 18px;
    border: 1px solid #d8d8d8;
    }
    .click_img_con{
      position: absolute;
      top:55px;
      left: 50%;
      margin-left: -20px;
    }
    .qr_code{
      width: 150px;
      height:150px;
      vertical-align: top;
      border-radius: 18px;
    }
  }
}
</style>
